/**
 * DataElementsApi
 * DataElementsApi
 *
 * The version of the OpenAPI document: 1.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type DataTableStatus = 'ACTIVE' | 'DEVELOPMENT' | 'INACTIVE';

export const DataTableStatus = {
    Active: 'ACTIVE' as DataTableStatus,
    Development: 'DEVELOPMENT' as DataTableStatus,
    Inactive: 'INACTIVE' as DataTableStatus
};


export const DataTableStatusProps = {
} as const;

